
let distributorsT = require('../views/search-client/distributors.tri')
let searchT = require('../views/search-client/form.tri')
require('../views/search-client/prod-summary.tri')
require('../views/search-client/zip-summary.tri')
let noResultT = require('../views/search-client/no-results.tri')
let noProductT = require('../views/search-client/no-product.tri')
require('../views/search-client/distributor.tri')
require('../views/search-client/dist-location.tri')
require('../views/search-client/distributor-code.tri')
require('../views/search-client/website-line.tri')
let noZipCodeResult = require('../views/search-client/no-zip-code-result.tri')

module.exports = {
	distributorsResult: distributorsT
	, noDistributorsResult: noResultT
	, noProductResult: noProductT
	, searchForm: searchT
	, noZipCodeResult: noZipCodeResult
}

